import styled from 'styled-components';
import tw from 'twin.macro';
import { Button } from '../components';

const WeightContainer = styled.div<{ $isHidden: boolean }>`
  ${tw`absolute flex items-center top-12 left-0 mt-24 sm:mt-28 ml-2.5 sm:ml-7 z-10 gap-1`};
  ${({ $isHidden }) =>
    $isHidden ? tw`animate-slideOutTop` : tw`animate-slideInTop`};
`;

const InnerContainer = styled.div`
  ${tw`flex flex-wrap`};

  gap: 0.2rem 0.4rem;
`;

const TopRightWrapper = styled.div`
  ${tw`fixed top-3 right-3 sm:top-7 sm:right-7 z-30`};
`;

const ButtonContainer = styled.div`
  ${tw`flex gap-1.5 justify-end	`};
`;

const TableContainer = styled.div`
  ${tw`relative flex-1 flex flex-col`};
  min-height: 0; /* Allow flex child to shrink */
`;

const HideButton = styled(Button)<{ $isHidden: boolean }>`
  ${tw`inline-block transition-transform duration-500 border-white`};

  ${({ $isHidden }) =>
    $isHidden
      ? tw`bg-buttonSelectedBg text-white -rotate-0`
      : tw`bg-white rotate-180`};
`;

const RoundButtonThatCanHide = styled(Button)<{ $isHidden: boolean }>`
  ${tw`transition-transform duration-500`};
  ${({ $isHidden }) =>
    $isHidden ? tw`animate-slideOutTop` : tw`animate-slideInTop`};
`;

const ContentContainer = styled.div<{ $isFilterHidden?: boolean; $isMapVisible?: boolean }>`
  ${tw`relative w-full h-full flex flex-col overflow-hidden`};
  min-height: 0;
  ${({ $isMapVisible }) => {
    // Apply padding only when map is hidden (to prevent overlap with tabs)
    if (!$isMapVisible) {
      return tw`pt-16 sm:pt-20`;
    }
    // No padding when map is visible
    return '';
  }};
`;

export {
  ContentContainer,
  WeightContainer,
  InnerContainer,
  TopRightWrapper,
  ButtonContainer,
  TableContainer,
  HideButton,
  RoundButtonThatCanHide
};
